// extracted by mini-css-extract-plugin
export default {"Button":"dropdown-caret-module__Button--ne4ys"};